"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEMBERSHIP_API_URLS = exports.GROUPS_API_URLS = void 0;
exports.GROUPS_API_URLS = {
    USER_GROUPS: 'users/groups/',
    GROUPS: 'groups/',
};
exports.MEMBERSHIP_API_URLS = {
    INVITE: 'memberships/invite/',
    MEMBERSHIPS: 'memberships/',
    GET_BY_GROUP: 'memberships?',
};
